// Initialize Cloud Firestore through Firebase
import { initializeApp } from "firebase/app"
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore"
import { firebaseConfig } from './config/firebase.js';

const firebaseApp = initializeApp(firebaseConfig);

const db = getFirestore(firebaseApp);

export async function getRates() {
    const docRef = doc(db, "cottages", "rates");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
//      console.log("Document data:", docSnap.data());
      return docSnap.data();
    } else {
    // doc.data() will be undefined in this case
      console.log("No such document!");
    }  
}

export async function getAvailability() {
  const docRef = doc(db, "cottages", "availability");
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
//    console.log("Bookings data:", docSnap.data());
    return docSnap.data();
  } else {
  // doc.data() will be undefined in this case
    console.log("No such document!");
  }  
}

export async function saveAvailability(bookings) {

  await setDoc(doc(db, "cottages", "availability"), bookings);
  return;
}

  